import React, { forwardRef } from "react";
import BaseSvgIcon from "@mui/material/SvgIcon";
import { getClassName } from "@sscs/utils";
import styles from "./icon.module.scss";
export { BaseSvgIcon };
/**
 * Wraps a MUI-backed `SvgIcon` in the unified icon API. Size and colour are applied as unlayered
 * CSS-module classes reading `--sscs-*` tokens; because component SCSS sits outside MUI's `@layer
 * mui`, they win over MUI's own `fontSize`/`color`, so the icon re-themes (incl. dark mode) for free.
 *
 * @param viewBox Override for custom glyphs whose native grid is not MUI's 24×24. Omit for `@mui/icons-material`.
 */
export function createIcon(MuiIcon, displayName, viewBox) {
    const Icon = forwardRef(function Icon({ size = "sm", color = "inherit", className, titleAccess, ...rest }, ref) {
        const classNames = getClassName(styles.root, styles[`size-${size}`], color === "inherit" ? undefined : styles[`color-${color}`], className);
        return (React.createElement(MuiIcon, { ...rest, ref: ref, fontSize: "inherit", viewBox: viewBox, titleAccess: titleAccess, "aria-hidden": titleAccess || rest["aria-label"] ? undefined : true, className: classNames }));
    });
    Icon.displayName = displayName;
    return Icon;
}
//# sourceMappingURL=IconBase.js.map